var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebdev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#0244be",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952 1147 c-62 -210 -132 -448 -156 -530 l-44 -147 102 0 103 0 152 517 c84 284 155 522 158 530 4 10 -16 13 -98 13 l-104 0 -113 -383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 1167 l-350 -163 -3 -80 -3 -80 288 -134 c158 -73 321 -148 361 -166 l72 -33 0 107 0 107 -218 94 c-119 52 -220 97 -224 100 -4 3 93 50 215 103 l222 96 3 106 c1 58 -1 106 -5 106 -4 -1 -165 -74 -358 -163z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282 1225 l3 -107 228 -97 229 -98 -231 -99 -231 -99 0 -107 0 -108 33 15 c17 9 178 82 357 164 l325 148 3 84 3 84 -343 157 c-189 86 -351 160 -361 164 -16 6 -17 -1 -15 -101z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdev);
export default __webpack_public_path__ + "static/media/webdev.18d82b983dda952131501e180a2eef0c.svg";
export { ForwardRef as ReactComponent };